import { createFeatureSelector, createSelector } from '@ngrx/store';

export const helpStateSelector = createFeatureSelector<any>('help');
export const helpActionSelector = createSelector(helpStateSelector, (state: any) => state.action);